import src from "IMAGE";
export default { src, width: 717, height: 683, blurWidth: 0, blurHeight: 0};
